import React from 'react';

type TProps = {
  fallback: React.ReactNode;
  onError?: (error: Error) => void;
};

type TState = {
  hasError: boolean;
};

class ErrorBoundary extends React.Component<TProps, TState> {
  static getDerivedStateFromError() {
    return { hasError: true };
  }

  constructor(props: TProps) {
    super(props);
    this.state = { hasError: false };
  }

  componentDidCatch(error: Error) {
    if (this.props.onError) {
      this.props.onError(error);
    }
  }

  render() {
    if (this.state.hasError) {
      return this.props.fallback;
    }

    return this.props.children;
  }
}

export { ErrorBoundary };
